
export class ArquivoDocumento {

    grupo: string;
    nome: string;
    extensao: string;
    arquivo: File;
    tipo: string;
    hash: string;
    qtdePaginas: number;

}